


































































































































































































































































import { Component, Prop, Mixins } from 'vue-property-decorator'

// Mixins
import TableSortMixin from '@/components/mixins/TableSortMixin.vue'

// Interfaces
import { IDropdownList } from '@/_interfaces'

// Model
import UserModel from '@/_models/UserModel'

// Helpers
import { hasAlert, isCardOff } from '@/_utils/card'
import { Constant } from '@/_services/constant'

// Components
import NotFound from '@/components/common/NotFound.vue'
import DropdownSearch from '@/components/common/buttons/DropdownSearch.vue'
import LastUpdatedJbox from '@/components/shared/LastUpdatedJbox.vue'
import TablePagination from '@/components/shared/TablePagination.vue'
import BatteryLevel from '@/components/shared/BatteryLevel.vue'
import UserType from '@/components/shared/UserType.vue'
import SearchButton from '@/components/shared/SearchButton.vue'
import TrackingButtons from './partials/TrackingButtons.vue'
import CategoryButtons from './partials/CategoryButtons.vue'

@Component({
  components: {
    LastUpdatedJbox,
    BatteryLevel,
    UserType,
    NotFound,
    TablePagination,
    SearchButton,
    TrackingButtons,
    CategoryButtons,
    DropdownSearch,
  },
})
export default class UserSearchListTable extends Mixins(TableSortMixin) {
  @Prop()
  parent!: any

  @Prop()
  hasButtonGotoOutdoor!: boolean

  @Prop({ default: false })
  isHideTablePagination!: boolean

  isCardOff: any = isCardOff
  hasAlert: any = hasAlert
  defaultCategoryColor = Constant.DEFAULT_CATEGORY_COLOR

  dropdownList: IDropdownList[] = [
    {
      value: 'name',
      label: this.$t('label.username').toString(),
    },
    {
      value: 'category_name',
      label: this.$t('label.category').toString(),
    },
    {
      value: 'san_id',
      label: this.$t('label.card_number').toString(),
    },
  ]

  filedNameLUT: any = {
    _id: 'UUID',
    user_id: 'label.user_id',
    name: 'label.username',
    category_name: 'label.category',
    san_id: 'label.card_number',
  }

  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  get filteredText(): string {
    const filterList = {
      _id: 'UUID',
      user_id: 'label.user_id',
      name: 'label.username',
      category_name: 'label.category',
      san_id: 'label.card_number',
    }
    if (this.parent.pageFilters.selectedFilter !== '' && this.parent.pageFilters.searchQuery !== '') {
      const selectedFilterText = this.$t(filterList[this.parent.pageFilters.selectedFilter])
      return [selectedFilterText, this.parent.pageFilters.searchQuery].join(': ')
    }

    return ''
  }

  get isShowColumn() {
    return !this.$isMobileSize()
  }

  handleRemoveCheckedUser(user: UserModel): void {
    for (let index = this.parent.checkedRows.length - 1; index >= 0; --index) {
      const u = this.parent.checkedRows[index]
      if (u._id === user._id) {
        this.parent.checkedRows.splice(index, 1)
        break
      }
    }

    this.parent.filterUtilCheckedRows.save(this.parent.checkedRows)
  }

  handleClearFilter(): void {
    this.parent.pageFilters = {
      currentPage: 1,
      perPage: 10,
      selectedFilter: '',
      searchQuery: '',
    }
    this.parent.filterUtilInOutdoorTable.clear()
  }

  showPanelCamera() {
    this.parent.showCameraPanel()
  }

  trackingUserSelected() {
    this.parent.trackingUserSelected()
  }

  created() {
    this.tableRef = 'userSearchListTable'
  }
}
